import styles from "./Warnings.module.css";
import { CalculatorWarning } from "../../state";
import { Warning } from "./Warning";

import type { JSX } from "react";

type WarningsProps = {
  warnings: CalculatorWarning[];
};

const Warnings = (props: WarningsProps): JSX.Element | null => {
  const { warnings } = props;

  if (warnings.length < 1) {
    return null;
  }

  return (
    <div className={styles.warnings}>
      {warnings.map((warning) => (
        <Warning key={warning.type} {...warning} />
      ))}
    </div>
  );
};

export { Warnings };
